import { useState } from 'react';
import { fetchWithTimeout } from '../../../utils/fetch';

const fetch = fetchWithTimeout(3000);
export const useUserDeliveryAndPickupDetails = ({ userInfo } = {}) => {
  const [userLocationData, setUserLocationData] = useState({
    isOutOfMarket: undefined,
    city: undefined,
    state: undefined,
    zip5: undefined,
    isUserInfoLoaded: false
  });
  const { accessToken, isAuthLoading } = userInfo || {};


  if (!isAuthLoading && !userLocationData.isUserInfoLoaded)
    fetch(process.env.GATSBY_DELIVERY_PICKUP_DETAILS, {
      headers: {
        authorization: `Bearer ${accessToken || ''}`,
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        Expires: '0'
      }
    })
      .then((res) => res.json())
      .then((data) => {
        setUserLocationData({
          isOutOfMarket: data?.soonestDeliveryAvailable?.isThirdPartyDelivery,
          city: data?.userLocation?.city,
          state: data?.userLocation?.state,
          zip5: data?.userLocation?.zip5,
          isUserInfoLoaded: true
        });
      })
      .catch((error) => {
        console.error('Unable to get delivery and pickup details', error);
        setUserLocationData({ isUserInfoLoaded: true });
      });

  return userLocationData;
};
